import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import Vuetify from 'vuetify'

// i18n
import en from 'vuetify/src/locale/en.ts'
import de from 'vuetify/src/locale/de.ts'
import bg from '../config/lang/vuetify/bg'
import sv from '../config/lang/vuetify/sv'

Vue.use (Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#339900',
        secondary: '#004203',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { en, de, bg, sv },
    current: 'en'
  },
});

